'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bus-school';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5dd';
var svgPathData = 'M176 336C176 353.7 161.7 368 144 368C126.3 368 112 353.7 112 336C112 318.3 126.3 304 144 304C161.7 304 176 318.3 176 336zM400 336C400 353.7 385.7 368 368 368C350.3 368 336 353.7 336 336C336 318.3 350.3 304 368 304C385.7 304 400 318.3 400 336zM464 94.98V128H480C497.7 128 512 142.3 512 160V224C512 241.7 497.7 256 480 256H467C484.1 274.7 496 300.1 496 328V384C496 413.8 475.6 438.9 448 445.1V488C448 501.3 437.3 512 424 512C410.7 512 400 501.3 400 488V448H112V488C112 501.3 101.3 512 88 512C74.75 512 64 501.3 64 488V445.1C36.4 438.9 16 413.8 16 384V328C16 300.1 27.02 274.7 44.95 256H32C14.33 256 0 241.7 0 224V160C0 142.3 14.33 128 32 128H48V94.98C48 86.18 50.01 74.43 58.41 64.42C82.89 35.23 145.9 0 256 0C373.7 0 430.9 35.09 454.3 64.96C461.1 74.8 464 86.1 464 94.98zM96 96H180.3C185.8 86.44 196.2 80 208 80H304C315.8 80 326.2 86.44 331.7 96H416V94.98C416 94.54 415.1 94.19 415.9 93.93L415.9 93.87C404.2 79.44 363.5 48 255.1 48C156.9 48 109.6 79.11 96.02 94.3C96.01 94.48 95.1 94.71 95.1 94.98L96 96zM96 144V226.8C103.7 224.1 111.7 224 120 224H232V144H96zM416 144H280V224H392C400.3 224 408.3 224.1 416 226.8V144zM120 272C89.07 272 64 297.1 64 328V384C64 392.8 71.16 400 80 400H432C440.8 400 448 392.8 448 384V328C448 297.1 422.9 272 392 272H120z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBusSchool = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;